export {default as BaseError} from './BaseError';
export type {BaseErrorProps} from './BaseError';
